import { api } from './api-core';
import moment from 'moment';
// import { IUser } from './school-api';
// import { IUser } from '@/contexts/UserContext';
// export interface INotificationItem {
//     oldId: string;
//     id: string;
//     title: string;
//     content: string;
//     link: string;
//     createdAt: string;
// }
// export interface INotification {
//     data: INotificationItem[];
//     seen: string[];
// }
// export interface INotificationNtfy {
//     click: string;
//     event: string;
//     expires: number;
//     oldId: string;
//     id: string;
//     message: string;
//     time: number;
//     title: string;
//     topic: string;
// }

// Updated interface to include read status
export interface INotificationItem {
    oldId: string;
    id: string | number;
    title: string;
    content: string;
    link?: string;
    createdAt: string;
    read: boolean; // Added read status
}
// Updated interface to include read_noti array
export interface INotification {
    data: INotificationItem[];
    seen: string[];
    read_noti?: string[]; // Added read_noti array
}

export interface INotificationNtfy {
    click: string;
    event: string;
    expires: number;
    id: string;
    message: string;
    time: number;
    title: string;
    topic: string;
}
export const NotificationApi = {
    // getNotifications2: async (user:any,topic?:string):Promise<INotification> => {
    //     var nu=new URLSearchParams();
        
    //     if(topic){
    //         nu.append('topic',topic);
    //     } else {
    //         nu.append('topic',user.user_login);
    //     }
    //     // nu.append('topic', "devtestv1");
    //     var paras=nu.toString();
    //     // user.token_kc="eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJ3VUZMQkZzZlhiZkNxN2d1WDNSNEhDUGJrUUc0NnlDTVB4WnNOQllHNE5NIn0.eyJleHAiOjE3NDAxMTc2MzQsImlhdCI6MTc0MDExMDQzNCwianRpIjoiMTdmNTAyMjgtM2M0Zi00OTY1LTgyNTktN2Q4MDliZTUxNDQwIiwiaXNzIjoiaHR0cHM6Ly9pZC5sZWFuYm90LnNwYWNlL2F1dGgvcmVhbG1zL2lkcCIsImF1ZCI6WyJyZWFsbS1tYW5hZ2VtZW50IiwiYWNjb3VudCJdLCJzdWIiOiJkMjQ1MWVkMi1jZGFlLTQ3ZDUtYTI0Yi1iMTQxNGMzYmI3NDgiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJxYS5weXRoYXZlcnNlLnNwYWNlIiwiYWNyIjoiMSIsImFsbG93ZWQtb3JpZ2lucyI6WyJodHRwczovL3FhLnB5dGhhdmVyc2Uuc3BhY2UiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbImRlZmF1bHQtcm9sZXMtaWRwIiwib2ZmbGluZV9hY2Nlc3MiLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7InJlYWxtLW1hbmFnZW1lbnQiOnsicm9sZXMiOlsidmlldy1pZGVudGl0eS1wcm92aWRlcnMiLCJ2aWV3LXJlYWxtIiwibWFuYWdlLWlkZW50aXR5LXByb3ZpZGVycyIsImltcGVyc29uYXRpb24iLCJyZWFsbS1hZG1pbiIsImNyZWF0ZS1jbGllbnQiLCJtYW5hZ2UtdXNlcnMiLCJxdWVyeS1yZWFsbXMiLCJ2aWV3LWF1dGhvcml6YXRpb24iLCJxdWVyeS1jbGllbnRzIiwicXVlcnktdXNlcnMiLCJtYW5hZ2UtZXZlbnRzIiwibWFuYWdlLXJlYWxtIiwidmlldy1ldmVudHMiLCJ2aWV3LXVzZXJzIiwidmlldy1jbGllbnRzIiwibWFuYWdlLWF1dGhvcml6YXRpb24iLCJtYW5hZ2UtY2xpZW50cyIsInF1ZXJ5LWdyb3VwcyJdfSwiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJwcm9maWxlIGVtYWlsIiwiY2xpZW50SWQiOiJxYS5weXRoYXZlcnNlLnNwYWNlIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJjbGllbnRIb3N0IjoiMjcuNzIuMzEuMzIiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJzZXJ2aWNlLWFjY291bnQtcWEucHl0aGF2ZXJzZS5zcGFjZSIsImNsaWVudEFkZHJlc3MiOiIyNy43Mi4zMS4zMiJ9.HVgW4FCSQ3e3hQjjC3bYlPA34nbyZrKg4fVZLAokUqjI6eEQmRpTifsyNaa9ZQ1DgtEbtyWs3UMNPr_2hHo5WK3m91cBY1yM2nuLRAVAnJf6A6KclQ5kwO7QluQOZftk9ueXYp6NN1VPLds852UYH5X1JGVVgaAKW_toBgvWM-68n XZzQ4ngloatXeZpcXkvC5hyfQsxHxvIA-sHhk2ZfYOQq1x7Wy398V64kuADlVZEGBp5XTKa1OQcz-H--xxFvMD1lqvY4_3K-ATDQ6ut2sqsLBwSUXulxXnv_ARP-ouKV1iZ42zvEWNWvJif3G7Js58w8tbLy2jgYraRIAkzWg";
    //     // debugger;
    //     // const response = await api.get(`${process.env.NOTIFICATION_GET_URL}`,{
    //     const response = await api.get(`${process.env.NOTIFICATION_GET_URL}?${paras}`,{
    //         headers:{
    //             'X-WP-Nonce':user.token||"",
    //             Authorization: `Bearer ${user.token_kc}`
    //         }
    //     });
    //     // var rs=(response?.data||[]).map((item:any)=>item.data)
    //     // .reduce((prev,curr)=>{
            
    //     //     prev.push(...curr);
    //     //     return prev;
    //     // },[]) as INotificationNtfy[];
    //     var rs=(response?.data?.data||[]) as INotificationNtfy[];
    //     // debugger;
    //     return {data:rs.map((item)=>{
    //         return {
    //             oldId:item.id,
    //             id:item.time as any,
    //             title:item.title,
    //             content:item.message,
    //             link:item.click as any,
    //             createdAt:moment().utc(item.time as any).format('YYYY-MM-DD')
    //         }
    //     }),seen:[]};
    // },

    getNotifications2: async (user: any, topic?: string): Promise<INotification> => {
        const formData = new FormData();
        const response = await api.post(`${process.env.API_GET_NOTIFICATIONS_DATA}`, formData, {});
      
        console.log(response);
      
        // Extract data and read_noti from response
        const notificationData = response?.data?.data || [];
        const readNotificationIds = response?.data?.read_noti || [];
      
        // Map the notification data
        const mappedData = notificationData.map((item: INotificationNtfy) => {
            return {
                oldId: item.id,
                id: item.time,
                title: item.title || '',
                content: item.message || '',
                link: item.click || '',
                createdAt: moment.unix(item.time).format('YYYY-MM-DD'),
                read: readNotificationIds.includes(item.id) // Set read status based on read_noti
            };
        });
      
        return {
            data: mappedData,
            seen: [],
            read_noti: readNotificationIds
        };
    },

    markNotificationsAsRead: async (user: any, notificationIds: string[], status: number): Promise<boolean> => {
        try {
            const formData = new FormData();
            formData.append(`status`, status.toString());
            if (Array.isArray(notificationIds)) {
                // Xử lý trường hợp là mảng
                notificationIds.forEach((item) => {
                    formData.append(`notification_ids[]`, item.toString());
                });
            }
            // formData.append('notification_ids', JSON.stringify(notificationIds));
            
            const response = await api.post(`${process.env.API_MARK_NOTIFICATIONS_READ}`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            // const url = process.env.API_MARK_NOTIFICATIONS_READ;
            // return api
            // .post(url as string, formData, {
            //     headers: { "Content-Type": "multipart/form-data" },
            // })
            // .then((res) => res.data)
            // .catch((err) => {
            //     console.error("Error in upload avatar:", err);
            //     throw err; // Ném lỗi để xử lý ở nơi gọi hàm
            // });
            
            return response.data?.status === 'success' || response.data?.status === true;
        } catch (error) {
            console.error('Error marking notifications as read:', error);
            return false;
        }
    },

    sendNotification: async (user:any,title:string,content:string,topic:string):Promise<any> => {
        const formData = new FormData();
        formData.append('title',title);
        formData.append('message',content);
        formData.append('topic',topic);
        const response = await api.post(`${process.env.NOTIFICATION_POST_URL}`,formData,{
            headers:{
                'Content-Type':'application/x-www-form-urlencoded',
                'X-WP-Nonce':user.token||"",
                Authorization: `Bearer ${user.token_kc}`
            }
        });
        return response.data;
    },
    getNotifications: async (user:any):Promise<INotification> => {
        const response = await api.get('/wp-json/notify/v1/list',{
            headers:{
                'X-WP-Nonce':user.token||""
            }
        });
        return response.data;
    },
    setLastSeenId: async (user:any,id:string):Promise<void> => {
        const formData = new FormData();
        formData.append('seen',id);
        const response = await api.post('/wp-json/notify/v1/seen',formData,{
            headers:{
                'Content-Type':'application/x-www-form-urlencoded',
                'X-WP-Nonce':user.token||""
            }
        });
        return response.data;
    }
}

